$(document).ready(function(){

  var header = $('header');
  var headerOffset = header.offset().top;

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass('sticky');
      $("body").addClass("stick_icons");
    } else {
      header.removeClass('sticky');
      $("body").removeClass("stick_icons");
    }
  });
  
  if ($('#landing__slider').length) {
    $('#landing__slider').owlCarousel({
            loop: true,
            margin:0,
            nav:false,
            dots: true,
            items:1,
            autoplay:true,
            autoplayTimeout: 8000,
            animateIn: 'fadeIn',
            animateOut:'fadeOut'
    });
  }

  if ($("#Groom_Review_Slider").length) {
      $("#Groom_Review_Slider").owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout:8000,
        autoplaySpeed: 1000,
        margin: 30,
        nav: false,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          767: {
            items: 1
          },
          992: {
            items: 3
          }
        }
      });
  }


  $('.play_motions_video').on('click', function(ev) {
    $("#motion_video").fadeIn();
    $("#motion_video").attr("src", "https://www.youtube.com/embed/EngW7tLk6R8?&showinfo=0&rel=0&autoplay=1")
      ev.preventDefault();
    });

  $(".menuic").click(function() {
    $(this).toggleClass("active");
    $("body").toggleClass("active");
  });

    
  $(".accord_title h3").click(function(){
    if ($(this).parent().hasClass("accordshow")) {
      $(".accord_title").removeClass('accordshow');
      $('.accord_desc').slideUp();
      return false;
    }
    $('.accord_desc').slideUp();
    $(".accord_title").removeClass('accordshow');
    $(this).next().slideDown();
    $(this).parent().addClass('accordshow');
  });



  $(".play_video_popup").click(function(){
    $('html, body').css('overflowY', 'hidden');
    $("#youtubeVideo").fadeIn();
    youtube_id = $(this).data('youtube');
    $("#youtubeVideo iframe").attr("src","https://www.youtube.com/embed/"+youtube_id+"?autoplay=1&enablejsapi=1&vq=large&rel=0&autohide=1&controls=1&iv_load_policy=3&theme=light&color=white&showinfo=0");
  });
  $(".play_mp4_popup").click(function(){
    $('html, body').css('overflowY', 'hidden');
    $("#mp4Video").fadeIn();
    mp4_url = $(this).data('mp4');
    $("#mp4Video video").attr("src",mp4_url);
  });
  $(".close_popup").click(function(){
    $('html, body').css('overflowY', 'auto');
    $("iframe").attr("src","");
    $("video").attr("src","");
    $("#youtubeVideo, #mp4Video").fadeOut();
  });
  
}); //end jquery

